<template>
  <div class="relative">
   <div class="h-80 bg-bgheader absolute w-full"></div>
   <div class="absolute w-full">
   <div class="flex flex-col justify-center">
      <h1 class="text-right text-lg font-bold pt-9 mr-2 text-white">
        لیست محصولات
      </h1>
      <div class="flex flex-row justify-center items-center">
        <input
          class="border text-center p-2 rounded-lg text-cyan-900 bg-white shadow-lg mt-8 w-4/5 ml-1"
          type="text"
          placeholder="جستجو ..."
          v-model="vlaSearch"
          @keyup.enter="search"
        />

        <div
          class="flex justify-center py-1.5 px-2 mt-8 bg-bgbutton border border-yellow-500 rounded-xl shadow-md"
          @click="search"
        >
          <font-awesome-icon
            icon="magnifying-glass"
            class="fa-xl text-bgfont mt-1"
          />
        </div>
      </div>
    </div>
     <div class="relative mt-4 mx-4">
      <div
        class="flex overflow-x-auto space-x-2 snap-x snap-mandatory no-scrollbar"
        ref="category"
      >
        <div
          class="flex items-center justify-center shrink-0 snap-center"
          v-for="cat in category"
          :key="cat.id"
          @click="filterCategory(cat.id)"
        >
          <div class="text-center flex flex-col">
            <div class="p-1 mx-1 transition-all">
              <img
                :src="`https://tabarokauth.takhtjamshid.com/${cat.imgUrl}`"
                class="w-10 h-9 rounded-lg shadow-xl object-cover"
              />
            </div>
            <p class="text-xs mr-2 mt-1 text-white">{{ cat.title }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-4 my-8 mx-4 mb-20">
      <div
        class="bg-white p-5 rounded-xl shadow-xl text-center"
        v-for="pro in product"
        :key="pro.kala_Code"
      >
        <!-- <span
          class="absolute bg-red-500 p-1 rounded-2xl text-xs text-white z-10"
          v-if="discount"
          >5%</span
        > -->
        <router-link to="#">
          <img
            :src="pro.imgUrl"
            class="h-28 relative mx-auto rounded-3xl"
            :alt="pro.kala_Name"
            @error="
              $event.target.src = require('@/assets/img/image_placeholder.png')
            "
          />
        </router-link>
        <div class="relative group inline-block max-w-[120px]">
          <h2 class="text-sm mt-2 text-cyan-900 truncate leading-5">
            {{ pro.kala_Name ? pro.kala_Name : "بدون نام" }}
          </h2>

          <!-- tooltip فقط وقتی اسم وجود داره -->
          <div
            v-if="pro.kala_Name"
            class="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 z-10 whitespace-nowrap shadow-md"
          >
            {{ pro.kala_Name }}
          </div>
        </div>

        <h3 class="text-xs text-gray-600 mt-1">
          {{ pro.pack_Name }}
        </h3>
        <h6 class="text-sm font-bold mt-1 text-green-600">
          {{ $helper.priceFormatter(pro.salE_NERKH / 10) }}
        </h6>
        <h6 class="text-sm mt-1 text-bgfont" v-if="pro.dscnt_Percent">
          {{ $helper.priceFormatter(pro.nerkH_WITH_TAX / 10) }}
        </h6>
        <h6 class="text-xs mt-1 text-bgfont">
          موجودی {{ pro.mojodi / pro.pack_Value }} بسته
        </h6>
        <ProductOrderButtons :product="pro" />
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import { getCategory, getProduct, searchProduct } from "@/API/API";
import ProductOrderButtons from "@/components/ProductOrderButtons";
import { debounce } from "lodash";
export default {
  name: "ProductPage",
  components: { ProductOrderButtons },
  data() {
    return {
      discount: true,
      category: [],
      product: [],
      custid: this.$route.params.customerId,
      anbar: this.$route.params.anbarId,
      vlaSearch: "",
    };
  },
  async created() {
    this.debouncedSearch = debounce(this.search, 500);
    this.category = (await getCategory()).data.result;
    const id = this.category[0].id;
    this.product = (
      await getProduct(id, this.custid, this.anbar)
    ).data.result.products;
  },
  methods: {
    onBodyScroll() {},
    onScroll() {},
    async filterCategory(id) {
      this.product = (
        await getProduct(id, this.custid, this.anbar)
      ).data.result.products;
    },
    async search() {
      if (!this.vlaSearch.trim()) return;
      this.product = (
        await searchProduct(this.vlaSearch, this.anbar, this.custid)
      ).data.result;
      console.log(this.product);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onBodyScroll);
    this.$refs.category.addEventListener("scroll", this.onScroll);
  },
  watch: {
    vlaSearch() {
      this.debouncedSearch();
    },
  },
};
</script>
<style scoped>
.price-table td,
th {
  @apply border border-yellow-300 p-2;
}

.price-table .table-cell-profit {
  @apply border-t-2 border-yellow-300;
}
.scroll-div {
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: row;
  margin-top: 5px;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none; /* IE و Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
